<form class="payment-tab-form" [formGroup]="PaymentTab">
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="pay-width">
      <mat-label>Pay/Refund</mat-label>
      <mat-select formControlName="payRefund">
        <mat-option [value]="true">Pay</mat-option>
        <mat-option [value]="false">Refund</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="method-width">
      <mat-label class="boldlabel">Method</mat-label>
      <mat-select formControlName="paymentTypeId">
        <mat-option *ngFor="let rl of PaymentTypes" [value]="rl.id">
          {{rl?.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="pay-width">
      <mat-label class="boldlabel">Ref/Check #</mat-label>
      <input maxlength="20" matInput placeholder="Ref/Check #" formControlName="checkNumber" value="">
    </mat-form-field>
    <mat-form-field class="method-width">
      <mat-label class="boldlabel">Amount</mat-label>
      <input matInput placeholder="Amount" formControlName="amount" value="">
    </mat-form-field>
  </div>
  <div class="bottom-line"></div>
  <div fxLayout="row" fxLayoutGap="50px" class="d-flex justify-content-center">
    <span style="font-weight: bold">Status Selections
    </span>
  </div>
  <ul>
    <li><b>Approve</b> - Activate and send notification to applicant's email
    </li>
    <li><b>Reject</b> - Select rejection reason(s) and send notification to applicant's email
    </li>
    <li><b>Supervisor Review</b> - Review is needed before approve/reject can be determined
    </li>
    <li><b>Waiting on Customer</b> - Additional info/corrections needed from applicant
    </li>
  </ul>
  <div *ngIf="OnlinePayment" fxLayout="row" fxLayoutGap="50px"
    class="d-flex justify-content-center applicant-background-color">
    <span class='applicant-span'>Online Payment</span>
  </div>
  <div *ngIf="  OnlinePayment">
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Online Payment Confirmation</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{OnlinePayment?.fisAuthorizationNumber }}</div>
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Payment Type</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{OnlinePayment?.fisPaymentType}}</div>
    </div>
    <div class="row">
      <div class="col-12"></div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12" style="text-align: center;">Payment Contact Info</div>
      <div class="col-lg-6 col-md-6 col-sm-12" style="text-align: center;">Payment Billing Info</div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Name</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{  getApplicantName() }}</div>
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Name</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{OnlinePayment?.fisBillingName}}</div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Address</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{getMailingAddress()}}</div>
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Address</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{ billingAddress }}</div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Email</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{  this.getValue('QualificationTab', 'contactEmail') }}</div>
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Email</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{OnlinePayment?.fisBillingEmail }}</div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Phone</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{ this.getValue('QualificationTab', 'contactPhone') }}</div>
      <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Phone</div>
      <div class="col-lg-3 col-md-3 col-sm-6">{{OnlinePayment?.fisBillingPhone }}</div>
    </div>
  </div>
</form>
